// extracted by mini-css-extract-plugin
module.exports = {"image-value-widget":"_3ywSr_","progressive-container":"_312yBx","aspect-image-container":"SFzpgZ","actual-img":"_2r_T1I","scale-width":"_3LYy9o","preload-img":"_2dOLJS"};